import { render, staticRenderFns } from "./ApplicationCategoryForm.vue?vue&type=template&id=2415a91a&scoped=true"
import script from "./ApplicationCategoryForm.vue?vue&type=script&lang=js"
export * from "./ApplicationCategoryForm.vue?vue&type=script&lang=js"
import style0 from "./ApplicationCategoryForm.vue?vue&type=style&index=0&id=2415a91a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2415a91a",
  null
  
)

export default component.exports